import { DialogOverlay, DialogContent } from '@reach/dialog';
import classNames from 'classnames';
import * as React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Modal = function Modal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      initialFocusRef = _ref.initialFocusRef,
      isOpen = _ref.isOpen,
      max640 = _ref.max640,
      onDismiss = _ref.onDismiss,
      roomy = _ref.roomy,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "initialFocusRef", "isOpen", "max640", "onDismiss", "roomy"]);

  React.useEffect(function () {
    if (isOpen) {
      document.body.classList.add('modal--document-body');
      return function () {
        return document.body.classList.remove('modal--document-body');
      };
    }
  }, [isOpen]);
  var overlayClassName = classNames('modal modal--is-active', props.overlayClassName, {
    'modal--is-max640': max640,
    'modal--is-roomy': roomy
  });
  var containerClassName = classNames('modal__container', className);
  return /*#__PURE__*/React.createElement(DialogOverlay, {
    allowPinchZoom: true,
    className: overlayClassName,
    initialFocusRef: initialFocusRef,
    isOpen: isOpen,
    onDismiss: onDismiss
  }, /*#__PURE__*/React.createElement(DialogContent, _extends({
    className: containerClassName
  }, props), children));
};
Modal.displayName = "Modal";

var ModalContent = function ModalContent(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('modal__content', className)
  }, props));
};

ModalContent.displayName = "ModalContent";

var ModalFooter = function ModalFooter(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('modal__footer', className)
  }, props));
};

ModalFooter.displayName = "ModalFooter";

export default Modal;
export { ModalContent as Content, ModalFooter as Footer, Modal, ModalContent, ModalFooter };
//# sourceMappingURL=index.es.js.map
